import React from "react";
import { History } from "history";
import moment from "moment";
import { Page } from "../..";
import {
  Box,
  Alerta,
  TipoAlerta,
  Row,
  Col,
  Botao,
  CampoEstatico,
  TipoCampoEstatico,
  TipoBotao,
  CampoValor,
  CampoTexto,
} from "@intechprev/componentes-web";
import { PlanoVinculadoEntidade, NaturezaEmprestimoEntidade, ContratoEmprestimoEntidade } from "../../../entidades";
import { IParametrosSimulacao } from ".";
import { ContratoEmprestimoService } from "../../../services";

interface Props {
  history?: History;
}

interface State {
  dadosSimulacao: IParametrosSimulacao;
  dadosResumo: any;
}

export class EmprestimosSimuladorResumo extends React.Component<Props, State> {
  private page = React.createRef<Page>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    const dados: IParametrosSimulacao = JSON.parse(localStorage.getItem("emprestimo-parametros"));

    this.state = {
      dadosSimulacao: dados,
      dadosResumo: {
        resumo: {},
        imposto: {},
        prestacoes: {},
      },
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);

    const parametros = {
      SqNatureza: this.state.dadosSimulacao.natureza.SQ_NATUREZA,
      SqPlanoPrevidencial: this.state.dadosSimulacao.plano.SQ_PLANO_PREVIDENCIAL,
      ValorSolicitado: this.state.dadosSimulacao.valorSolicitado,
      Tabela: this.state.dadosSimulacao.tabela,
      TabelaPrazo: this.state.dadosSimulacao.prestacao.Prazo,
      TabelaTaxa: Number(this.state.dadosSimulacao.prestacao.Taxa),
      TabelaValor: Number(this.state.dadosSimulacao.prestacao.Valor),
      ValorCorrecao: this.state.dadosSimulacao.valorCorrecao,
      ValorJurosAdicional: this.state.dadosSimulacao.valorJurosAdicional,
    };

    console.log({ parametros });

    var dadosResumo = await ContratoEmprestimoService.BuscarResumo(parametros);

    await this.setState({
      dadosResumo,
    });

    await this.page.current.loading(false);
  };

  continuar = async () => {
    this.props.history.push("/emprestimosSimuladorToken");
  };

  render() {
    return (
      <Page {...this.props} ref={this.page}>
        <h3>Bem-Vindo ao Simulador de Empréstimos da EQTPREV!</h3>
        <h5>Ao final da sua simulação você poderá realizar o requerimento do seu empréstimo diretamente por aqui, de forma on-line e segura!</h5>

        <Box titulo={"Resumo dos Cálculos"}>
          {this.state.dadosResumo.mensagem && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.dadosResumo.mensagem} />}

          {!this.state.dadosResumo.mensagem && (
            <>
              <CampoTexto
                contexto={this}
                nome={"DS_PLANO_PREVIDENCIAL"}
                titulo="Plano"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosSimulacao.plano.DS_PLANO_PREVIDENCIAL}
                desabilitado
              />

              <CampoTexto
                contexto={this}
                nome={"DS_NATUREZA"}
                titulo="Natureza do Empréstimo"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosSimulacao.natureza.DS_NATUREZA}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"valorSolicitado"}
                titulo="Valor Solicitado"
                tamanhoTitulo={"lg-3"}
                valor={Number(this.state.dadosSimulacao.valorSolicitado)}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"ValorSaldoReforma"}
                titulo="Contratos a Reformar"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosResumo.resumo.ValorSaldoReforma}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"valorJurosAdicional"}
                titulo="Juros Ad"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosSimulacao.valorJurosAdicional}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"valorCorrecao"}
                titulo="Correção"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosSimulacao.valorCorrecao}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"valorCorrecao"}
                titulo="Valor Financiado"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosResumo.prestacoes.ValorFinanciado}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"totalEncargos"}
                titulo="Total de Encargos/Tributos*"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosResumo.totalEncargos}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"totalEncargos"}
                titulo="Valor Líquido"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosResumo.imposto.ValorLiquido}
                desabilitado
              />

              <CampoTexto
                contexto={this}
                nome={"dataCredito"}
                titulo="Data de Crédito"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosResumo.dataCredito}
                desabilitado
              />

              <h5 className="mt-5">
                <b>Prestações</b>
              </h5>

              <CampoTexto
                contexto={this}
                nome={"Prazo"}
                titulo="Prazo (meses)"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosSimulacao.prestacao.Prazo}
                desabilitado
              />

              <CampoTexto
                contexto={this}
                nome={"Taxa"}
                titulo="Taxa"
                tamanhoTitulo={"lg-3"}
                valor={this.state.dadosSimulacao.prestacao.Taxa.toFixed(6).replace(".", ",")}
                desabilitado
              />

              <CampoValor
                contexto={this}
                tipo={"dinheiro"}
                nome={"Valor"}
                titulo="Prestação Inicial Prevista"
                tamanhoTitulo={"lg-3"}
                valor={Number(this.state.dadosSimulacao.prestacao.Valor)}
                desabilitado
              />

              <h5 className="mt-5">
                <b>* Encargos/Tributos Calculados</b>
              </h5>

              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Encargo/Tributo</th>
                    <th>Taxa</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.dadosResumo.imposto.listaImpostoEncargo &&
                    this.state.dadosResumo.imposto.listaImpostoEncargo.map((imposto: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{imposto.Nome}</td>
                          <td>{imposto.Taxa}%</td>
                          <td>
                            <CampoEstatico valor={imposto.Valor} tipo={TipoCampoEstatico.dinheiro} />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              <Botao titulo={"Gostei! Quero requerer esse empréstimo!"} onClick={this.continuar} className="mt-3" />
              <br />

              <Botao titulo={"Selecionar outro prazo"} onClick={() => this.props.history.goBack()} tipo={TipoBotao.light} className="mt-3" />
            </>
          )}
        </Box>
      </Page>
    );
  }
}
